"use client";

import { Box, Button, Container, Stack, Typography } from "@mui/material";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import Link from "next/link";
import { PARTNERS_PAGE } from "@/constants/partners-page";

export const PartnersCta = () => {
  const { cta } = PARTNERS_PAGE;

  return (
    <Container maxWidth="lg" sx={{ mt: { xs: 8, md: 12 }, mb: { xs: 4, md: 6 } }}>
      <Box
        sx={{
          borderRadius: 6,
          px: { xs: 3, md: 8 },
          py: { xs: 6, md: 8 },
          textAlign: "center",
          color: "primary.contrastText",
          background:
            "linear-gradient(135deg, var(--mui-palette-primary-main) 0%, var(--mui-palette-primary-dark) 100%)",
        }}
      >
        <Typography variant="h4" component="h2" sx={{ fontWeight: 700, mb: 1.5 }}>
          {cta.title}
        </Typography>
        <Typography
          variant="body1"
          sx={{ maxWidth: 620, mx: "auto", mb: 4, opacity: 0.92, lineHeight: 1.7 }}
        >
          {cta.subtitle}
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1.5}
          justifyContent="center"
          useFlexGap
          flexWrap="wrap"
        >
          <Button
            component={Link}
            href={cta.contactHref}
            size="large"
            variant="contained"
            sx={{
              borderRadius: 999,
              textTransform: "none",
              px: 4,
              py: 1.25,
              boxShadow: "none",
              bgcolor: "background.paper",
              color: "primary.dark",
              "&:hover": { bgcolor: "background.paper", opacity: 0.92, boxShadow: "none" },
            }}
          >
            {cta.contactLabel}
          </Button>
          <Button
            component={Link}
            href={cta.loginHref}
            size="large"
            variant="outlined"
            startIcon={<LoginRoundedIcon />}
            sx={{
              borderRadius: 999,
              textTransform: "none",
              px: 4,
              py: 1.25,
              color: "primary.contrastText",
              borderColor: "rgba(255,255,255,0.7)",
              "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,0.12)" },
            }}
          >
            {cta.loginLabel}
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};
